/* ============================================================
   THE WOODEN NEST — theme.js
   Storefront interactivity. Page routing + product catalog are
   handled by Shopify Liquid, so none of that lives here.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  window.toggleDrawer = function () {
    var d = document.getElementById('mobileDrawer');
    var o = document.getElementById('drawerOverlay');
    if (d) d.classList.toggle('open');
    if (o) o.classList.toggle('open');
  };

  /* ---------- Accordion (product details + FAQ) ---------- */
  window.toggleAccordion = function (h) {
    if (h && h.parentElement) h.parentElement.classList.toggle('open');
  };

  /* ---------- Quantity stepper ---------- */
  window.updateQty = function (d) {
    var el = document.getElementById('qtyVal');
    if (!el) return;
    var next = Math.min(10, Math.max(1, parseInt(el.textContent, 10) + d));
    el.textContent = next;
    var hidden = document.getElementById('hiddenQty');
    if (hidden) hidden.value = next;
  };

  /* ---------- Generic swatch selection (wood / hook finish) ---------- */
  window.selectSwatch = function (el) {
    if (!el || !el.parentElement) return;
    el.parentElement.querySelectorAll('.swatch, .swatch-photo').forEach(function (s) {
      s.classList.remove('selected');
    });
    el.classList.add('selected');
    var group = el.closest('.option-group');
    var label = group ? group.querySelector('.swatch-label') : null;
    if (label && el.title) label.textContent = el.title;
    // Write the chosen value into the matching hidden line-item-property input
    var input = group ? group.querySelector('input.prop-input') : null;
    if (input && el.title) input.value = el.title;
  };

  /* ---------- Bench seat wood → swap main image to the seat photo ---------- */
  window.selectSeatWood = function (el) {
    if (!el || !el.parentElement) return;
    el.parentElement.querySelectorAll('.swatch, .swatch-photo').forEach(function (s) {
      s.classList.remove('selected');
    });
    el.classList.add('selected');
    var group = el.closest('.option-group');
    var label = group ? group.querySelector('.swatch-label') : null;
    if (label && el.title) label.textContent = el.title + ' — 1″ solid seat';
    var input = group ? group.querySelector('input.prop-input') : null;
    if (input && el.title) input.value = el.title;
    var img = el.getAttribute('data-img');
    var main = document.getElementById('pdMainImg');
    if (main && img) {
      main.src = img;
      main.alt = el.title + ' bench seat';
    }
  };

  /* ---------- Stain chip selection (26 colors) ---------- */
  window.selectStain = function (el) {
    var grid = document.getElementById('pdStainGrid');
    if (grid) {
      grid.querySelectorAll('.stain-chip').forEach(function (c) {
        c.classList.remove('selected');
      });
    }
    if (el) el.classList.add('selected');
    var label = document.getElementById('stainLabel');
    if (label && el && el.title) label.textContent = 'Selected stain: ' + el.title;
    var input = document.getElementById('stainInput');
    if (input && el && el.title) input.value = el.title;
  };

  /* ---------- Paint-color swatch → swap main image + label ---------- */
  window.selectColor = function (el) {
    if (!el) return;
    var img = el.getAttribute('data-img');
    var name = el.getAttribute('data-color') || el.title || '';
    var main = document.getElementById('pdMainImg');
    if (main && img) {
      main.src = img;
      main.alt = name;
    }
    var label = document.getElementById('colorLabel');
    if (label && name) label.textContent = name;
    document.querySelectorAll('#pdColorSwatches .swatch').forEach(function (s) {
      s.classList.toggle('selected', s === el);
    });
    document.querySelectorAll('#pdThumbRow .thumb').forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-img') === img);
    });
    var input = document.getElementById('paintColorInput');
    if (input && name) input.value = name;
  };

  /* ---------- Thumbnail swap ---------- */
  window.selectThumb = function (el) {
    if (!el) return;
    var img = el.getAttribute('data-img');
    var name = el.getAttribute('data-color') || '';
    var main = document.getElementById('pdMainImg');
    if (main && img) {
      main.src = img;
      if (name) main.alt = name;
    }
    document.querySelectorAll('#pdThumbRow .thumb').forEach(function (t) {
      t.classList.toggle('active', t === el);
    });
    if (name) {
      document.querySelectorAll('#pdColorSwatches .swatch').forEach(function (s) {
        s.classList.toggle('selected', s.getAttribute('data-color') === name);
      });
      var label = document.getElementById('colorLabel');
      if (label) label.textContent = name;
      var input = document.getElementById('paintColorInput');
      if (input) input.value = name;
    }
  };

  /* ---------- Toast + cart count helpers ---------- */
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cartCount, .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- Card colour swatch → swap the card image ---------- */
  window.pd2cSwatch = function (el) {
    if (!el) return;
    var card = el.closest('.pd2c-card');
    if (!card) return;
    var img = el.getAttribute('data-img');
    var main = card.querySelector('.pd2c-img-a');
    if (main && img) main.src = img;
    card.querySelectorAll('.pd2c-dot').forEach(function (d) {
      d.classList.toggle('is-active', d === el);
    });
  };

  /* ---------- Quick add (the "+" on product cards) ---------- */
  window.quickAdd = function (btn) {
    if (!btn) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.disabled = false;
        if (!res.ok) { showToast((res.d && res.d.description) || 'Could not add — open the product page'); return; }
        btn.classList.add('is-added');
        btn.textContent = '✓';
        setTimeout(function () { btn.textContent = '+'; btn.classList.remove('is-added'); }, 1400);
        showToast('Added to cart');
        refreshCartCount();
      })
      .catch(function () { btn.disabled = false; showToast('Could not add — open the product page'); });
  };

  /* ---------- Collection filter tabs (progressive enhancement) ----------
     Links already work without JS (they navigate to collection URLs).
     This just marks the active tab visually if JS is present. ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.filter-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        document.querySelectorAll('.filter-tab').forEach(function (t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });

    // Keep the hidden quantity field in sync on load
    var qv = document.getElementById('qtyVal');
    var hidden = document.getElementById('hiddenQty');
    if (qv && hidden) hidden.value = qv.textContent.trim();
  });
})();
